export default "__VITE_ASSET__C_JWi9fJ__"